import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NDA_COPIES, NDA_ICON, NdaStatus } from 'models/Nda';
import usePastTime from 'hooks/usePastTime';
import ResolvePopup from 'components/ResolvePopup';
import { isNdaRejected } from 'utils';

import './NdaStatusBadge.styles.scss';

type NdaStatusBadgeProps = {
  className?: string;
  status: NdaStatus;
  sentDate?: Date;
  signedDate?: Date;
  rejectionReason?: string;
};

const NdaStatusBadge: React.FC<NdaStatusBadgeProps> = (props) => {
  const { className, status, sentDate, signedDate, rejectionReason } = props;
  const { t } = useTranslation();

  const classes = classNames('nda-status-badge', status, className);

  const Icon = useMemo(() => NDA_ICON[status], [status]);

  const pastTime = usePastTime();

  return (
    <ResolvePopup
      onHover
      className="nda-status-badge-popup"
      popupContent={
        <div className="nda-status-badge-popup__content">
          <span className="nda-status-copy">{t(NDA_COPIES[status])}</span>

          {isNdaRejected(status) ? (
            rejectionReason && <p>{rejectionReason}</p>
          ) : signedDate ? (
            <p>{pastTime(signedDate)}</p>
          ) : (
            sentDate && <p>{pastTime(sentDate)}</p>
          )}
        </div>
      }
    >
      <div className={classes}>
        {t('nda')}
        <Icon />
      </div>
    </ResolvePopup>
  );
};

export default NdaStatusBadge;
